"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertContextProvider = exports.useAlertContext = exports.AlertAction = exports.AlertContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const alert_reducer_1 = require("./alert.reducer");
const alertContextDefaultValues = {
    state: {
        alerts: []
    },
    dispatch: () => {
    }
};
exports.AlertContext = (0, react_1.createContext)(alertContextDefaultValues);
exports.AlertAction = alert_reducer_1.alertReducerActions;
const useAlertContext = () => (0, react_1.useContext)(exports.AlertContext);
exports.useAlertContext = useAlertContext;
const AlertContextProvider = ({ children }) => {
    const [state, dispatch] = (0, react_1.useReducer)(alert_reducer_1.alertReducer, alertContextDefaultValues.state);
    const alertValues = (0, react_1.useMemo)(() => ({
        state, dispatch
    }), [state, dispatch]);
    return ((0, jsx_runtime_1.jsx)(exports.AlertContext.Provider, { value: alertValues, children: children }));
};
exports.AlertContextProvider = AlertContextProvider;
